import { Col, Collapse, Row } from "antd";
import { isNull } from "lodash";
import React, { useEffect, useMemo, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { setExpandSectionsAction } from "../../../../store/document/documentActions";
import NoExpiryDocumentSummary from "../NoExpiryDocumentSummary";
import PaymentDocumentPanel from "./PaymentDocumentPanel";
import PaymentTransactionPaymentPanel from "./PaymentTransactionPaymentPanel";

const PaymentTransactionView = ({ isNew }) => {
  const { control } = useFormContext();
  const dispatch = useDispatch();
  const [activeKeys, setActiveKeys] = useState(["1", "2", "3"]);

  const expandSections = useSelector(
    (state) => state.document.selectedUi.expandSections
  );

  useEffect(() => {
    if (!isNull(expandSections)) {
      dispatch(setExpandSectionsAction(null));
      setActiveKeys(expandSections ? ["1", "2", "3"] : []);
    }
  }, [expandSections, dispatch]);

  const onActiveKeyChangeHandler = (keys) => {
    setActiveKeys(Array.isArray(keys) ? keys : [keys]);
  };

  const items = useMemo(
    () => [
      {
        key: "1",
        label: "Summary",
        children: <NoExpiryDocumentSummary isNew={isNew} />,
      },
      {
        key: "2",
        label: "Document",
        children: <PaymentDocumentPanel control={control} isNew={isNew} />,
      },
      {
        key: "3",
        label: "Payment",
        children: <PaymentTransactionPaymentPanel control={control} />,
      },
    ],
    [control, isNew]
  );

  return (
    <>
      <Row>
        <Col span={24}>
          <Collapse
            items={items}
            activeKey={activeKeys}
            onChange={onActiveKeyChangeHandler}
            size="small"
          />
        </Col>
      </Row>
    </>
  );
};

export default PaymentTransactionView;
